import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../common/RootState.type'
import { calcDeepRGB } from '../util/calcDeepRGB'
import { hex2Rgba } from '../util/hex2rgba'

const initialState = {
  baseColor: '',
  iconColor: '',
  bgColor: '',
  headerColor: '',
  opacity: '',
  fontColor: '',
  fontSize: '',
}

export const settingSlice = createSlice({
  name: 'setting',
  initialState,
  reducers: {
    resetColor: (state) => {
      const rootStyle = getComputedStyle(document.documentElement)
      return {
        ...state,
        baseColor: rootStyle.getPropertyValue('--base-color').trim(),
        iconColor: rootStyle.getPropertyValue('--base-icon-color').trim(),
        bgColor: rootStyle.getPropertyValue('--base-bg-color').trim(),
        headerColor: rootStyle.getPropertyValue('--base-header-color').trim(),
        opacity: rootStyle.getPropertyValue('--base-opacity').trim(),
        fontColor: '',
        fontSize: '1rem',
      }
    },
    changeColor: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        baseColor: hex2Rgba(action.payload, '1'),
        iconColor: calcDeepRGB(action.payload),
        bgColor: hex2Rgba(action.payload, state.opacity),
        headerColor: hex2Rgba(action.payload, '0.4'),
      }
    },
    changeOpacity: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        opacity: action.payload,
      }
    },
    changeFontSize: (state) => {
      return {
        ...state,
      }
    },
  },
})

export const selectBaseColor = (state: RootState) => state.setting.baseColor
export const selectIconColor = (state: RootState) => state.setting.iconColor
export const selectBgColor = (state: RootState) => state.setting.bgColor
export const selectHeaderColor = (state: RootState) => state.setting.headerColor
export const selectOpacity = (state: RootState) => state.setting.opacity
export const selectFontColor = (state: RootState) => state.setting.fontColor
export const selectFontSize = (state: RootState) => state.setting.fontSize

export const { changeColor, changeOpacity, changeFontSize, resetColor } =
  settingSlice.actions
